<div class="ttmodal" >
  <div class="ttmodal__header">
    <span class="ttmodal__title">
     {{'Component Note' | translate | async}}
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">

    <div>
      <mat-form-field class="example-full-width" style="min-width: 500px;">
        <textarea matInput placeholder="{{'Action Comment' | translate | async}}" [(ngModel)]="comment"></textarea>
      </mat-form-field>
    </div>

  
 
  </div>
   <div class="ttmodal__footer">
     <button mat-raised-button color="warn" (click)="save()"> {{'Save/Update' | translate | async}} </button>
  </div> 
</div>